module.exports = __webpack_public_path__ + "img/tpc-web-3.633cf9bd.jpg";